import React, { useMemo } from "react";
import { connect } from "react-redux";
import { Table } from "semantic-ui-react";
import { arrayOf, bool, func, instanceOf, number } from "prop-types";
import { I18nShape } from "shared/shapes/i18n.shape";
import DocumentAssignmentShape from "shared/shapes/documentAssignment.shape";
import { useLocalStorage } from "beautiful-react-hooks";
import OptionsShape from "shared/shapes/options.shape";
import { getAccount } from "shared/selectors";
import { renderTableHeader, renderTableBody } from "./TablePartsRenderers";
import { DocumentExportsResource } from "../../../actions/documentsActions";
import {
  getExportFilterOptions,
  exportColumns
} from "../../../selectors/documentExports";

import "./documentExport.scss";

const getValidFilters = filters => {
  const allowed_filters = ["name", "role"];
  const temp = {};
  allowed_filters.forEach(key => {
    if (filters[key]) temp[key] = filters[key];
  });
  return temp;
};

const ExportsTab = ({
  i18n,
  list,
  isLoading,
  loadData,
  documentExportsResource,
  filterOptions,
  accountId
}) => {
  const [filtersA, setFilters] = useLocalStorage("documentExportFilters", {});
  const filters = useMemo(() => filtersA[accountId] || {}, [filtersA]);

  const applyFilter = (name, vals) => {
    if (accountId) {
      setFilters({});
      setFilters({ [accountId]: { ...filters, [name]: vals.value } });
    }
  };

  const filterList = useMemo(() => {
    if (!filters) return list;
    let data = [...list];
    const validFilters = getValidFilters(filters);

    Object.keys(validFilters).forEach(key => {
      const value = filters[key];
      if (value) data = data.filter(x => x[key] === value);
    });
    return data;
  }, [filters, list]);

  const handlers = {
    handleSubmit: model => {
      return documentExportsResource.save(model).then(() => {
        loadData();
      });
    },
    handleDelete: id => {
      return documentExportsResource.remove(id).then(() => {
        loadData();
      });
    },
    handlePreview: () => {},
    handleDuplicate: () => {},
    handleDuplicateAll: () => {}
  };

  return (
    <Table>
      {renderTableHeader({
        i18n,
        columns: exportColumns,
        list,
        handlers,
        applyFilter,
        title: "documentsExport.menu.exports.title",
        dialog: "export",
        filterOptions,
        filters: getValidFilters(filters),
        setFilters
      })}
      {renderTableBody({
        i18n,
        columns: exportColumns,
        list: filterList,
        isLoading,
        handlers,
        dialog: "export"
      })}
    </Table>
  );
};

ExportsTab.propTypes = {
  i18n: I18nShape.isRequired,
  list: arrayOf(DocumentAssignmentShape),
  isLoading: bool.isRequired,
  documentExportsResource: instanceOf(DocumentExportsResource).isRequired,
  loadData: func.isRequired,
  filterOptions: OptionsShape.isRequired,
  accountId: number
};

ExportsTab.defaultProps = {
  list: [],
  accountId: undefined
};

const mapStateToProps = state => {
  return {
    filterOptions: getExportFilterOptions(state),
    accountId: getAccount(state)?.data?.account?.id
  };
};

export default connect(mapStateToProps)(ExportsTab);
